import { SegmentedControl, type SegmentedOption } from "../ui/segmented-control"

/** The PnL window choices: calendar months back from today. */
const PNL_MONTHS_OPTIONS = [3, 6, 12, 24] as const

export const PNL_MONTHS_DEFAULT = 12

const OPTIONS: readonly SegmentedOption<string>[] = PNL_MONTHS_OPTIONS.map((months) => ({
  value: String(months),
  label: `${months}m`,
}))

type PnlMonthsPickerProps = {
  value: number
  onChange: (next: number) => void
  /** Names the control for assistive tech. */
  label: string
}

// The Marketplace profit & loss statement's own window control. It keeps its own
// months picker on purpose: the statement is a monthly finance view, independent
// of the dashboard's period picker. The value stays a number — `SegmentedControl`
// is string-keyed, so the mapping lives here rather than in the caller.
export function PnlMonthsPicker({ value, onChange, label }: PnlMonthsPickerProps) {
  return (
    <SegmentedControl
      options={OPTIONS}
      value={String(value)}
      onChange={(next) => onChange(Number(next))}
      label={label}
    />
  )
}
